const STEPS = [
  {
    n: "01",
    title: "Tell us about your app",
    body: "Just chat. \"I made a Next.js thing for tracking plants.\" That's enough — we'll figure out the rest."
  },
  {
    n: "02",
    title: "Connect your code",
    body: 'Paste a GitHub link or click "Connect GitHub". If your code is on your laptop, we\'ll show you how to push it (yes, even what `git push` means).'
  },
  {
    n: "03",
    title: "We summon a server",
    body: "A small computer ($4/mo) gets created in the cloud — yours, no shared resources. Think of it as renting a tiny apartment for your app to live in."
  },
  {
    n: "04",
    title: "You get a real URL",
    body: "We hook it all up — HTTPS, monitoring, auto-redeploy on git push. You get a link to share. That's it."
  }
];

export const HowItWorks = () => (
  <section id="how" className="max-w-[1140px] mx-auto px-8 py-24">
    <div className="max-w-[720px] mx-auto text-center mb-14">
      <div className="inline-block text-xs text-primary bg-primary/8 px-3 py-1 rounded-full mb-4 font-medium tracking-wide lowercase font-mono">
        how it works
      </div>
      <h2 className="font-serif text-[clamp(36px,5.5vw,56px)] leading-[1.05] tracking-tight font-normal mb-4 text-foreground text-balance">
        From localhost to <em className="text-primary">actual URL</em>, in 4 chats.
      </h2>
      <p className="text-[17px] leading-relaxed text-muted-foreground text-pretty">
        We explain everything as we go. No Docker. No Terraform. No SSH. No tears.
      </p>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3.5">
      {STEPS.map(s => (
        <div
          key={s.n}
          className="bg-card border rounded-xl p-7 shadow-sm hover:-translate-y-0.5 hover:shadow-md transition-all"
        >
          <div className="font-mono text-[22px] font-semibold text-primary bg-primary/8 inline-block px-2 py-0.5 rounded-md mb-4">
            {s.n}
          </div>
          <div className="text-[17px] font-semibold mb-2 tracking-tight">{s.title}</div>
          <div className="text-sm leading-relaxed text-muted-foreground">{s.body}</div>
        </div>
      ))}
    </div>
  </section>
);
